'use client';

import {
  Box,
  Button,
  Drawer as FreddyDrawer,
  DrawerFooter,
  Flex,
  Loader
} from '@coolblue-development/freddy';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useTranslation } from '@i18n/useTranslation';

import { useFilterDrawer } from '../../../context/DrawerContext';
import MobileFiltersTrigger from '../MobileFiltersTrigger';
import Body from './Body';

export default function Drawer() {
  const { clearFilters, hasAppliedFilters, isOpen, isPending, productCount, setIsOpen } =
    useFilterDrawer();

  const drawerTranslations = useFreddyTranslations('drawer');
  const { t } = useTranslation('webshop.filterPage.drawer');

  return (
    <>
      <MobileFiltersTrigger fab />

      <FreddyDrawer
        body={<Body />}
        footer={
          <DrawerFooter>
            <Flex px={200} pl={hasAppliedFilters ? 0 : 200} gap={200} sx={{ width: '100%' }}>
              {hasAppliedFilters && (
                <Button
                  onClick={clearFilters}
                  variant='tertiary'
                  sx={{
                    whiteSpace: 'nowrap'
                  }}
                >
                  {t('clearAllFilters')}
                </Button>
              )}

              <Button variant='primary' onClick={() => setIsOpen(false)} fullWidth>
                {isPending ? (
                  <Box sx={{ position: 'relative' }}>
                    <Loader size='small' />
                  </Box>
                ) : (
                  t('showProducts', { count: productCount })
                )}
              </Button>
            </Flex>
          </DrawerFooter>
        }
        open={isOpen}
        onClose={() => setIsOpen(false)}
        placement='right'
        sx={{
          maxWidth: '100%',
          width: '100%',
          fieldset: { marginTop: '0 !important' }
        }}
        title={t('filters')}
        translations={drawerTranslations}
      />
    </>
  );
}
